import React, { useState } from "react";
import { Link } from "react-router-dom";
import { notify } from "react-notify-toast";
import FormField from "../../Components/FormField/FormField";
import CancelButton from "../../Components/Buttons/CancelButton";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import Modal from "../../Components/Modal/Modal";
import { API } from "../../API";

export const ShareVideoModal = (props) => {
  const [sharedEmail, setSharedEmail] = useState("")
  // const [sharedMessage, setSharedMessage] = useState(
  // `Hi there, please take a look at this video ${props.video.name} from ReadyTeacher.`)
  const [showShareForm, displayShareForm] = useState(false)
  const shareVideoLink = `https://www.readyteacherapp.com/CollegeUserManual#${props.video.id}`

  const closeModal = () => {
    props.onClose();
    // setSharedMessage("");
    setSharedEmail("")
  }

  const handleShareVideo = () => {
    API.shareVideo(sharedEmail, props.video.name, shareVideoLink).then(() => {
      notify.show("Video shared successfully")
      closeModal();
    }).catch((err) => {
      notify.show("Error")
      console.log(err)
    })
  }

  return (
    <Modal
      show={true}
      className="share-profile-modal-new"
      header="Share Video"
      onClose={closeModal}
    >
      <div className="row mb-4 d-flex justify-content-between">
        <div className="col-12 m-auto">
          <p className=" mb-0 px-0 button-in-share-group">
            <Link
              className="mdi mdi-link-variant preview-profile-link-in-share"
              onClick={() => {
                navigator.clipboard.writeText(shareVideoLink);
                notify.show("Link copied to clipboard");
              }}
            >
              Copy Link
            </Link>
          </p>
        </div>
      </div>
      <div className="row mb-4 d-flex justify-content-between">
        <div className="col-12 m-auto">
          <p className=" mb-0 px-0 button-in-share-group">
            <p
              className="mdi mdi-email-outline preview-profile-link-in-share"
              onClick={() => displayShareForm(!showShareForm)}
            >
              Share via Email
            </p>
          </p>
        </div>
      </div>

      <div
        id="email-share-form"
        style={{ display: showShareForm ? "block" : "none" }}
      >
        <div className="row">
          <div className="col-12">
            <FormField
              type="textarea"
              rows="3"
              id="message"
              placeholder={ `Hi there, please take a look at this video ${props.video.name} from ReadyTeacher.` }
              // onChange={(e) => setSharedMessage(e.target.value)}
              // value={sharedMessage}
              disabled
            />

            <FormField
              icon="email"
              name="email"
              id="email"
              placeholder="Use semicolon to separate email addresses"
              autoFocus
              required
              value={sharedEmail}
              onChange={(e) => setSharedEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <CancelButton onClick={closeModal}>Cancel</CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton onClick={handleShareVideo} type="submit">Submit</ConfirmButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}